import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Webcam = createReactComponent("Webcam", ["svg", defaultAttributes, [["circle", {
  cx: "12",
  cy: "10",
  r: "8",
  key: "11tx6q"
}], ["circle", {
  cx: "12",
  cy: "10",
  r: "3",
  key: "1byug6"
}], ["path", {
  d: "M12 22v-4m-5 4h5-5zm10 0h-5 5z",
  key: "ki1bkt"
}]]]);
export default Webcam;